import { render, staticRenderFns } from "./SelectRateCategory.vue?vue&type=template&id=01945790"
import script from "./SelectRateCategory.vue?vue&type=script&lang=js"
export * from "./SelectRateCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports